module.exports = require("./lib/_stream_writable.js")



/*****************
 ** WEBPACK FOOTER
 ** (webpack)/~/stream-browserify/~/readable-stream/writable.js
 ** module id = 4203
 ** module chunks = 0
 **/